<template>
  <div>
		<p class="sub-title">Message type</p>
		<VSelect v-model="optionSelected" :disabled="isViewOnlyMode || isSmsChannel" aria-label="option" @change="onClickAction()" placeholder="Select message type" appearance="ghost" class="vivid-select vmb-10">
			<VOption v-if="showNoneOption" value="none" text="None"></VOption>
			<VOption v-if="activeActions.includes('text')" value="AddText" text="Text"></VOption>
			<VOption v-if="activeActions.includes('image')" value="AddImage" text="Image"></VOption>
			<VOption v-if="activeActions.includes('video')" value="AddVideo" text="Video"></VOption>
			<VOption v-if="activeActions.includes('document')" value="addDocument" text="File"></VOption>
			<VOption v-if="activeActions.includes('carousel')" value="carousel" text="Carousel"></VOption>
			<VOption v-if="activeActions.includes('carouselRcs')" value="carouselRcs" text="Carousel"></VOption>
			<VOption v-if="activeActions.includes('richcard')" value="richcardRcs" text="Rich Card"></VOption>
			<VOption v-if="activeActions.includes('quickReply')" value="AddQuickReplies" text="Quick Replies"></VOption>
		</VSelect>
   </div>
</template>

<script>
export default {
	emits: ['action'],
	props: {
		editBroadcast: {
			type: Object
		},
		selectedAction: {
			type: String,
			default:""
		},
		isViewOnlyMode: {
      type: Boolean,
      default: false
    },
		isEditMode: {
      type: Boolean,
      default: false
    },
		isGoogleRcsCompliance: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		isSmsChannel() {
			return this.editBroadcast?.channel === 'sms';
		},
		showNoneOption() {
			// Show NONE option only for Google RCS compliance
			return this.isGoogleRcsCompliance && this.editBroadcast?.channel === 'googlercs';
		},
		activeActions() {
			let activeActions = [];
			if (this.editBroadcast.channel == 'sms') {
				activeActions = ["text"];
			}
			else if (this.editBroadcast.channel == 'googlercs') {
				activeActions = ["text", "image", "video",  "document", "carouselRcs","quickReply", "richcard"];
			}
			else {
				activeActions = ["text", "image", "video", "carousel", "quickReply"];
			}
			return activeActions;
		}
	},
	watch: {
		selectedAction(n, o) {
			this.optionSelected = this.selectedAction;
		},
		'editBroadcast.channel': {
			immediate: false,
			handler(newChannel, oldChannel) {
				// When switching to SMS channel, always set to AddText and emit
				if (newChannel === 'sms' && oldChannel && oldChannel !== 'sms') {
					const hasExistingBroadcastData = this.editBroadcast?.id || this.editBroadcast?.page_id?.trim();
					if (!this.isViewOnlyMode && !this.isEditMode && !hasExistingBroadcastData) {
						this.optionSelected = 'AddText';
						this.$emit('action', { actionName: 'AddText' });
					}
				}
				// When switching away from SMS, reset selection if current option is not available
				else if (oldChannel === 'sms' && newChannel !== 'sms') {
					this.optionSelected = undefined;
				}
			}
		},
		activeActions: {
			immediate: true,
			handler(newActions) {
				// Check if this is a new broadcast (not edit or duplicate)
				const hasExistingBroadcastData = this.editBroadcast?.id || this.editBroadcast?.page_id?.trim();
				
				if ( this.editBroadcast.channel === 'sms' && !this.isViewOnlyMode && !this.isEditMode && !hasExistingBroadcastData ) {
					// Only emit if 'AddText' is not already selected
					if (this.optionSelected !== 'AddText') {
						this.optionSelected = 'AddText';
						let actionName = this.optionSelected;
						this.$emit('action', { actionName });
					}
				} else if (this.optionSelected !== 'none' && !newActions.includes(this.optionSelected)) {
					// Reset to default if the current selection is not valid (but allow "none")
					this.optionSelected = undefined;
				}
			},
		},
	},
  data() {
		return {
			optionSelected: undefined,
		}
	},
	methods: {
		onClickAction() {
			let actionName = this.optionSelected;
			this.$emit('action', { actionName });
		}
	}
}
</script>